import { EMPTY_OBJECT } from 'commons-ui';

import { DASHBOARD_RESOURCES } from 'constant';
import { URL } from '../../helper';
import useService from '../utils/userService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setForceUpdateRows } = params;
	const { handleDeleteSegmentData } = useService();

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[DASHBOARD_RESOURCES.cashbackUtil]}/create`
				});
			};
		case 'updateUtilPer':
			return () => {
				history.push({
					pathname: `${URL[DASHBOARD_RESOURCES.cashbackUtil]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'deletePriority':
			return async () => {
				await handleDeleteSegmentData(rowData?.segmentName);
				setForceUpdateRows(true);
			};

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
